import { render } from "./EmailListingSettingsHeader.vue?vue&type=template&id=126df2be"
import script from "./EmailListingSettingsHeader.vue?vue&type=script&lang=js"
export * from "./EmailListingSettingsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__